import React from "react";
import { useState, useEffect } from "react";
import Modal from "react-modal";
import { LOCATION, LOADING_SPIN } from "assets/constants/Icons";
import { TYPE_SUCCESS, TYPE_FAIL, INTERVAL } from "assets/constants/Constants";
import ShowToast from 'components/ShowToast';
import { captureLocationCall, getPartnerById } from "lib/axiosUtils";

Modal.setAppElement("#root");
const LocationCapture = (props) => {
    const [isLoadingCapture, setIsLoadingCapture] = useState(false);
    const [capturedLocation, setCapturedLocation] = useState(null);
    const [capturedLocationMsg, setCapturedLocationMsg] = useState(false);
    const [locationError, setLocationError] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [messageContent, setMessageContent] = useState("Location captured successfully.");

    useEffect(() => {
        setModalOpen(props.isOpen);
        async function fetchPartnerDetails() {
            const partnerData = await getPartnerById({}, {}, props.partnerId);
            if (partnerData && partnerData.statusCode === 200) {
                const partnerDetails = partnerData.data.result;
                if (partnerDetails && (partnerDetails.latitude || partnerDetails.longitude)) {
                    setMessageContent(`Location already captured, Please "CLICK TO UPDATE" to update your location`);
                    setCapturedLocation({ latitude: partnerDetails.latitude, longitude: partnerDetails.longitude });
                    setCapturedLocationMsg(true);
                }
            } else {
                setCapturedLocation(null);
                setCapturedLocationMsg(false);
                setLocationError("Unable to fetch partner details.");
                ShowToast("Unable to fetch partner details.", TYPE_FAIL, INTERVAL, "", "");
            }
        }
        if (props.partnerId) {
            fetchPartnerDetails();
        }
    }, [props]);

    const closeModal = () => {
        setModalOpen(false);
        props.closeModel();
    }

    const handleCaptureLocation = () => {
        setIsLoadingCapture(true);
        if (!navigator.geolocation) {
            const errorMessage = "Geolocation is not supported by your browser.";
            setLocationError(errorMessage);
            ShowToast(errorMessage, TYPE_FAIL, INTERVAL, "", "");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            async (position) => {
                setIsLoadingCapture(true);
                const { latitude, longitude } = position.coords;

                setCapturedLocation({ latitude, longitude });
                setLocationError(null);

                try {
                    const response = await captureLocationCall({}, { latitude, longitude, partnerId: props.partnerId });

                    if (response.statusCode === 200) {
                        ShowToast("Location captured and saved successfully!", TYPE_SUCCESS, INTERVAL, "", "");

                        setCapturedLocationMsg(true);
                        setIsLoadingCapture(false);

                    } else {
                        ShowToast("Location captured but not saved. Please try again.", TYPE_FAIL, INTERVAL, "", "");
                        setIsLoadingCapture(false);
                    }
                } catch (error) {
                    console.error("Error saving location to backend:", error);
                    ShowToast("Location captured, but error occurred while saving.", TYPE_FAIL, INTERVAL, "", "");
                    setIsLoadingCapture(false);
                }
            },
            (error) => {
                let errorMessage = "Unable to capture your location.";
                switch (error.code) {
                    case 1:
                        errorMessage = "Location permission denied. Please allow access to use this feature.";
                        break;
                    case 2:
                        errorMessage = "Location unavailable. Please ensure GPS or internet is active.";
                        break;
                    case 3:
                        errorMessage = "Location request timed out. Please try again.";
                        break;
                    default:
                        errorMessage = "An unknown error occurred while accessing your location.";
                        break;
                }

                setLocationError(errorMessage);
                setIsLoadingCapture(false);
                console.error("Error capturing location:", errorMessage);
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }
        );
    };

    return (
        <Modal
            isOpen={modalOpen}
            onRequestClose={closeModal}
            className="program-modal program-modal-dashboard"
            overlayClassName="program-modal-overlay"
            contentLabel="Location Capture Modal"
        >
            <div className="modal-header">
            </div>
            <div className="info-capture-location">
                <label className="bank-detail-label">Please ensure you are using a mobile phone and are present in the classroom while capturing the location.</label>
                <div className="section-div"></div>
            </div>
            <div className="modal-location">
                <div className="input-label-group col-md-6">
                    <label className="form-label">Latitude</label>
                    <input
                        className="form-control brand-font p-3 add-user-input-height location-input"
                        value={capturedLocation ? capturedLocation.latitude : ""}
                        readOnly={true}
                    />
                </div>
                <div className="input-label-group col-md-6">
                    <label className="form-label">Longitude</label>
                    <input
                        className="form-control brand-font p-3 add-user-input-height location-input"
                        value={capturedLocation ? capturedLocation.longitude : ""}
                        readOnly={true}
                    />
                </div>
                <div className="captured-location-div">
                    {
                        capturedLocationMsg && (
                            <p className="text-captured">
                                {messageContent}
                            </p>
                        )}
                    {
                        locationError && (
                            <p className="text-danger">
                                {locationError}
                            </p>
                        )
                    }
                </div>
            </div>
            <div className="form-button-div mt-4">
                {
                    isLoadingCapture ? (
                        <i className={LOADING_SPIN} />
                    ) : (
                        <button
                            type="button"
                            className="brand-button width-auto"
                            onClick={handleCaptureLocation}
                        >
                            <i className={`${LOCATION}`}>&nbsp;&nbsp;</i>
                            {capturedLocationMsg ? "Click to Update" : "Click to Capture"}
                        </button>
                    )
                }
                <button className="button-secondary ml-3" onClick={closeModal}>Cancel</button>
            </div>
        </Modal>
    );
};

export default LocationCapture;